import DOMAIN from 'constants/domains'
import { getDomain, isKsDomain, isSaficDomain } from 'utils/domain'

/**
 * 決定ボタンのデフォルトラベル
 */
export const DEFAULT_FORWARD_BUTTON_LABEL = isKsDomain()
  ? '決定'
  : isSaficDomain()
  ? '決定'
  : {
      [DOMAIN.SJ]: '決定',
    }[getDomain()]

/**
 * 戻るボタンのデフォルトラベル
 */
export const DEFAULT_BACK_BUTTON_LABEL = 'もどる'

/**
 * 必須項目未入力時の非活性ボタンのデフォルトラベル
 */
export const DEFAULT_DISABLED_BUTTON_LABEL = '必須項目を入力してください'

/**
 * 情報モーダルの確認済みボタンラベル
 */
export const MODAL_CONFIRMED_BUTTON_LABEL = 'OK'
